export default __webpack_public_path__ + "static/media/failedRuns.c7b7de35.svg";